import {Http} from '@/helpers/http-helper'
import router from '@/router'

const state = {
  menus: [],
  menu: {}
}

const getters = {
  getMenus: state => state.menus,
  getMenu: state => state.menu
}

const mutations = {
  setMenus (state, menus) {
    state.menus = menus
  },

  setMenu (state, menu) {
    state.menu = menu
  }
}

const actions = {
  search ({ commit }) {
    return Http.get('menus').then(response => {
      commit('setMenus', response.data)
      return response.data
    })
  },

  fetchMenus ({ commit, state }) {
    if (state.menus.length > 0) {
      return state.menus
    } else {
      return Http.get('menus/fetch').then(response => {
        commit('setMenus', response.data)
        return response.data
      })
    }
  },

  populateState ({ commit, dispatch }) {
    Http.get('menus/fetch').then(response => {
      commit('setMenus', response.data)
    })
  },

  details ({ commit }, id) {
    Http.get('menus/' + id).then(response => {
      commit('setMenu', response.data)
    }).catch(error => {
      console.log(error)
    })
  },

  save ({ commit, dispatch }, menu) {
    if (menu.id === undefined) {
      return Http.post('menus', menu).then(response => {
        dispatch('populateState')
        return response.data
      }).catch(error => {
        return Promise.reject(error)
      })
    } else {
      return Http.put('menus/' + menu.id, menu).then(() => {
        dispatch('populateState')
        router.push({name: 'MenusList'})
      }).catch(error => {
        return Promise.reject(error)
      })
    }
  },

  delete ({ commit, dispatch }, id) {
    return Http.delete('menus/' + id).then(() => {
      dispatch('populateState')
      // router.push({name: 'MenusList'})
    }).catch(error => {
      return Promise.reject(error)
    })
  },

  productMenu ({ commit }, id) {
    return Http.get('menus/product/' + id).then(response => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menus.js